import { Controller } from "@hotwired/stimulus";

// Controller dla Asystenta Pomocy AI w panelu admin (/admin/help/ask).
// Obsługuje skrót Enter -> wyślij, Shift+Enter -> nowa linia,
// stan loading na przycisku oraz auto-scroll listy wiadomości.
//
// Współpracuje z Turbo Streams: form jest submitowany jako turbo_stream,
// odpowiedź zawiera append do #help-messages + replace formularza/sidebaru.
export default class extends Controller {
  static targets = ["form", "textarea", "messages", "submit"];

  connect() {
    this._defaultSubmitText = this.hasSubmitTarget ? this.submitTarget.value || this.submitTarget.textContent : "Wyślij";
    this._pendingValue = null;
    this.scrollToBottom();
    if (this.hasTextareaTarget) {
      this.textareaTarget.focus();
    }
  }

  keydown(event) {
    if (event.key !== "Enter" || event.shiftKey || event.isComposing) return;
    if (!this.hasFormTarget) return;
    const target = event.target;
    if (target !== this.textareaTarget) return;

    event.preventDefault();
    if (target.value.trim() === "") return;
    this.formTarget.requestSubmit();
  }

  submitStart(event) {
    if (this.hasTextareaTarget) {
      this._pendingValue = this.textareaTarget.value;
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true;
      this._setSubmitLabel("Wysyłam…");
    }
  }

  submitEnd(event) {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false;
      this._setSubmitLabel(this._defaultSubmitText);
    }

    const success = event?.detail?.success === true;
    if (success) {
      if (this.hasTextareaTarget) {
        this.textareaTarget.value = "";
      }
      this._pendingValue = null;
      requestAnimationFrame(() => this.scrollToBottom());
      if (this.hasTextareaTarget) {
        this.textareaTarget.focus();
      }
    } else if (this.hasTextareaTarget && this._pendingValue !== null && this.textareaTarget.value === "") {
      // Awaria po stronie serwera — przywróć wpisaną treść.
      this.textareaTarget.value = this._pendingValue;
    }
  }

  scrollToBottom() {
    if (!this.hasMessagesTarget) return;
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight;
  }

  _setSubmitLabel(text) {
    if (!this.hasSubmitTarget) return;
    if (this.submitTarget.tagName === "INPUT") {
      this.submitTarget.value = text;
    } else {
      this.submitTarget.textContent = text;
    }
  }
}
